class StaticPage {
  constructor(
    public title: string,
    public content: string,
    public slug: string,
    public id: number | undefined,
    public id_user?: number | undefined
  ) {}

  public static EmptyInstance(): StaticPage {
    return new StaticPage("", "", "", -1, -1);
  }

}

export default StaticPage;
